export default {
    EM_ELABORACAO: 'Em Elaboração',
    ENVIADA: 'Enviada',
    CANCELADA: 'Cancelada'
}
